import { api } from './api';
import { fetchResource } from './fetchResource';

export function fetchAccountsModule() {
  return dispatch => fetchResource(dispatch, 'modules/accounts', 'ACCOUNTS_MODULE_FETCHED');
}

export function updateAccountsModule(payload) {
  return dispatch => {
    return api.put('/api/modules/accounts', payload).then(response => {
      dispatch({ type: 'ACCOUNTS_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function fetchRothRetirementAccounts() {
  return dispatch => fetchResource(dispatch, 'roth_retirement_accounts', 'ROTH_RETIREMENT_ACCOUNTS_FETCHED');
}

export function fetchNormalRetirementAccounts() {
  return dispatch => fetchResource(dispatch, 'normal_retirement_accounts', 'NORMAL_RETIREMENT_ACCOUNTS_FETCHED');
}

export function fetchRegularAccounts() {
  return dispatch => fetchResource(dispatch, 'regular_accounts', 'REGULAR_ACCOUNTS_FETCHED');
}

export function setAccountTypeSelected(type, isSelected) {
  return dispatch =>
    dispatch({ type: `SAVINGS_ACCOUNT_TYPE_${isSelected ? 'SELECTED' : 'UNSELECTED'}`, payload: type });
}

export function updateRothRetirementAccounts(accounts) {
  return dispatch => {
    return api.put('/api/roth_retirement_accounts', { roth_retirement_accounts: accounts }).then(response => {
      dispatch({ type: 'ROTH_RETIREMENT_ACCOUNTS_FETCHED', payload: response.data });
    });
  };
}

export function updateNormalRetirementAccounts(accounts) {
  return dispatch => {
    return api.put('/api/normal_retirement_accounts', { normal_retirement_accounts: accounts }).then(response => {
      dispatch({ type: 'NORMAL_RETIREMENT_ACCOUNTS_FETCHED', payload: response.data });
    });
  };
}

export function updateRegularAccounts(regularAccounts) {
  return dispatch => {
    return api.put('/api/regular_accounts', { regular_accounts: regularAccounts }).then(response => {
      dispatch({ type: 'REGULAR_ACCOUNTS_FETCHED', payload: response.data });
    });
  };
}
